import React, { Component } from "react";
import { connect } from "react-redux";
import { Breadcrumb } from "react-bootstrap";
import $ from "jquery";

class edocTypeView extends Component {
  constructor(props) {
    super(props);
    let encryptedId = this.props.location.search;
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );
    var Referenceno = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.state = {
      eDocTypeId: 0,
      eDocTypeName: "",
      Referenceno: Referenceno,
      applicablefor: "",
      status: "",
      userId: "",
      wfUserdefined: 1,
      approverList: [],
    };
  }

  componentDidMount() {
    $("#StafNamePopover").popover({ html: true });
    this.props.dispatch({ type: "headerTitle", value: "Create Request" });
    this.props.dispatch({ type: "Referenceno", value: "" });
    this.geteDocRequest();
  }

  geteDocRequest = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Admin/GeteDocType?eDocTypeId=${this.state.Referenceno}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.resultObject) {
              this.setState({
                eDocTypeId: data.resultObject[0]?.eDocTypeId,
                eDocTypeName: data.resultObject[0]?.eDocTypeName,
                applicablefor: data.resultObject[0]?.applicablefor,
                status: data.resultObject[0]?.status,
                wfUserdefined: data.resultObject[0]?.wfUserdefined,
                approverList: data.resultObject[0]?.approverList,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/edoctype/list"}>
            eDoc Type
          </Breadcrumb.Item>
          <Breadcrumb.Item active>View</Breadcrumb.Item>
        </Breadcrumb>
        <div className="content-area">
          <section className="view-taskpending-section">
            <div className="form-group mb-4">
              <h4>View eDoc Type</h4>
            </div>
          </section>

          <section className="view-taskpending-section">
            <h2 className="form-heading">eDoc Type Information</h2>
            <div className="form-group row mb-0">
              <label for="" className="col-sm-2 requester-info  col-form-label">
                eDoc Type
              </label>
              <div className="col-sm-4">
                <div className="input-group mb-2 mr-sm-2">
                  <p className="m-0 py-2">
                    <>
                      <span className="d-none d-sm-inline mytask-reference-text">
                        {" "}
                        :{" "}
                      </span>{" "}
                      <span className="mytask-reference-text">
                        {this.state.eDocTypeName}
                      </span>{" "}
                    </>{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="form-group row mb-0">
              <label for="" className="col-sm-2 requester-info  col-form-label">
                Applicable for
              </label>
              <div className="col-sm-4">
                <div className="input-group mb-2 mr-sm-2">
                  <p className="m-0 py-2">
                    <>
                      <span className="d-none d-sm-inline mytask-reference-text">
                        {" "}
                        :{" "}
                      </span>{" "}
                      <span className="mytask-reference-text">
                        {this.state.applicablefor}
                      </span>{" "}
                    </>{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="form-group row mb-0">
              <label for="" className="col-sm-2 requester-info  col-form-label">
                Status
              </label>
              <div className="col-sm-4">
                <div className="input-group mb-2 mr-sm-2">
                  <p className="m-0 py-2">
                    <>
                      <span className="d-none d-sm-inline mytask-reference-text">
                        {" "}
                        :{" "}
                      </span>{" "}
                      <span className="mytask-reference-text">
                        {this.state.status}
                      </span>{" "}
                    </>{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="form-group row mb-0">
              <label for="" className="col-sm-2 requester-info  col-form-label">
                Workflow User Defined
              </label>
              <div className="col-sm-4">
                <div className="input-group mb-2 mr-sm-2">
                  <p className="m-0 py-2">
                    <>
                      <span className="d-none d-sm-inline mytask-reference-text">
                        {" "}
                        :{" "}
                      </span>{" "}
                      <span className="mytask-reference-text">
                        {this.state.wfUserdefined == 1 ? "Yes" : "No"}
                      </span>{" "}
                    </>{" "}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="view-taskpending-section">
            <h2 className="form-heading">Workflow Setup</h2>
            <div className="customized-table">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="thead-lightBlue table-bordered">
                    <tr>
                      <th scope="col">Sequence No</th>
                      <th scope="col">Approver Name</th>
                      <th scope="col"> Section </th>
                    </tr>
                  </thead>
                  <tbody class="table-bordered">
                    {this.state.approverList?.map((dt) => (
                      <tr>
                        <td>{dt.seq}</td>
                        <td>{`${dt.employeeId}/${dt.employeeName}`}</td>
                        <td>{dt.section}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};
export default connect(mapStateToProps)(edocTypeView);
